/** Digits only, max length for a French SIRET (SIREN 9 + NIC 5). */
export function frenchSirenSiretDigitsOnly(raw: string): string {
  return raw.replace(/\D/g, "").slice(0, 14);
}

export function isFrenchSirenOrSiretDigitLength(digits: string): boolean {
  return digits.length === 9 || digits.length === 14;
}
